import axios, {AxiosResponse, AxiosRequestConfig, AxiosError} from 'axios';
import { useAlertStore } from '@/store/alert';

const config = {
   timeout: 10000,
   withCredentials: false,
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded',
  //   Accept: 'application/json',
  // },
};

// const onRequest = (config:AxiosRequestConfig) => {
//   //api 호출시 검증필요? ex)토큰 사용
//   return config;
// };


const onResponse = (response:AxiosResponse) => {
  return response;
};

const onError = (error:AxiosError) => {
  const useAlert  = useAlertStore();
  if(axios.isAxiosError(error)){
    useAlert.setAlert({
      isShow:true,
      isShowTitle:true,
      title:'API ERROR',
      info:`url : ${error.config.url}`,
      message:error.message
    });
    return new Promise(() => {});
  }else{
    useAlert.setAlert({
      isShow:true
    });
  }
  return Promise.reject(error);
};



const apiAdmin = axios.create(config);

//apiAdmin.interceptors.request.use(onRequest, onError);
apiAdmin.interceptors.response.use(onResponse, onError);

export default apiAdmin;
